var q = Object.defineProperty;
var A = s => {
    throw TypeError(s)
};
var H = (s, e, t) => e in s ? q(s, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
}) : s[e] = t;
var C = (s, e, t) => H(s, typeof e != "symbol" ? e + "" : e, t),
    _ = (s, e, t) => e.has(s) || A("Cannot " + t);
var r = (s, e, t) => (_(s, e, "read from private field"), t ? t.call(s) : e.get(s)),
    a = (s, e, t) => e.has(s) ? A("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(s) : e.set(s, t),
    c = (s, e, t, i) => (_(s, e, "write to private field"), i ? i.call(s, t) : e.set(s, t), t),
    T = (s, e, t) => (_(s, e, "access private method"), t);
import "./ll-product-form-yWOzeAST.js";
document.addEventListener("DOMContentLoaded", () => {
    window.redirectAllExternalLinksOut = function() {
        document.querySelectorAll("a[href]").forEach(e => {
            new URL(e.href, window.location.origin).origin !== window.location.origin && (!e.target || e.target !== "_blank") && (e.target = "_blank")
        })
    }, window.redirectAllExternalLinksOut()
});
var f, g, M;
!customElements.get("ll-header-menu") && customElements.get("header-menu") && customElements.define("ll-header-menu", (M = class extends customElements.get("header-menu") {
    constructor() {
        super();
        a(this, f);
        a(this, g);
        this.megaMenu = this.querySelector("details.mega-menu")
    }
    connectedCallback() {
        super.connectedCallback && super.connectedCallback(), c(this, f, this.onMenuItemHovered.bind(this)), c(this, g, this.onMenuItemHoveredOut.bind(this)), this.addEventListener("mouseover", r(this, f)), this.addEventListener("mouseleave", r(this, g))
    }
    disconnectedCallback() {
        this.removeEventListener("mouseover", r(this, f)), this.removeEventListener("mouseleave", r(this, g))
    }
    onMenuItemHovered(t) {
        this.megaMenu.setAttribute("open", !0)
    }
    onMenuItemHoveredOut(t) {
        this.megaMenu.removeAttribute("open")
    }
}, f = new WeakMap, g = new WeakMap, M));
class B extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach(e => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.site-selector__button)").forEach(e => e.addEventListener("click", this.onCloseButtonClick.bind(this)))
    }
    onKeyUp(e) {
        if (e.code.toUpperCase() !== "ESCAPE") return;
        const t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t))
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            i = t.parentNode,
            o = i.closest(".has-submenu"),
            n = i.hasAttribute("open"),
            l = window.matchMedia("(prefers-reduced-motion: reduce)");

        function h() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", h)
        }
        i === this.mainDetailsToggle ? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)) : setTimeout(() => {
            i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), o && o.classList.add("submenu-open"), !l || l.matches ? h() : t.nextElementSibling.addEventListener("transitionend", h)
        }, 100)
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(e, t = !1) {
        e !== void 0 && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(i => {
            i.removeAttribute("open"), i.classList.remove("menu-opening")
        }), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(i => {
            i.classList.remove("submenu-open")
        }), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(t), this.closeAnimation(this.mainDetailsToggle), e instanceof KeyboardEvent && (t == null || t.setAttribute("aria-expanded", !1)))
    }
    onFocusOut() {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        })
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t)
    }
    closeSubmenu(e) {
        const t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(e.querySelector("summary")), this.closeAnimation(e)
    }
    closeAnimation(e) {
        let t;
        const i = o => {
            t === void 0 && (t = o), o - t < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")))
        };
        window.requestAnimationFrame(i)
    }
}
customElements.define("ll-menu-drawer", B);
class O extends B {
    constructor() {
        super();
        C(this, "onResize", () => {
            this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
        })
    }
    openMenuDrawer(t) {
        this.header = this.header || document.querySelector(".section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), t.setAttribute("aria-expanded", !0), window.addEventListener("resize", this.onResize), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(t, i) {
        i && (super.closeMenuDrawer(t, i), this.header.classList.remove("menu-open"), window.removeEventListener("resize", this.onResize))
    }
}
customElements.define("ll-header-drawer", O);
class z extends HTMLElement {
    constructor() {
        super(), this.notification = document.getElementById("cart-notification"), this.header = document.querySelector("sticky-header"), this.onBodyClick = this.handleBodyClick.bind(this), this.notification.addEventListener("keyup", e => e.code === "Escape" && this.close()), this.querySelectorAll('button[type="button"]').forEach(e => e.addEventListener("click", this.close.bind(this)))
    }
    open() {
        this.notification.classList.add("animate", "active"), this.notification.addEventListener("transitionend", () => {
            this.notification.focus(), trapFocus(this.notification)
        }, {
            once: !0
        }), document.body.addEventListener("click", this.onBodyClick)
    }
    close() {
        this.notification.classList.remove("active"), document.body.removeEventListener("click", this.onBodyClick), removeTrapFocus(this.activeElement)
    }
    renderContents(e) {
        this.cartItemKey = e.key, this.getSectionsToRender().forEach(t => {
            document.getElementById(t.id).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector)
        }), this.header && this.header.reveal(), this.open()
    }
    getSectionsToRender() {
        return [{
            id: "cart-notification-product",
            selector: `[id="cart-notification-product-${this.cartItemKey}"]`
        }, {
            id: "cart-notification-button"
        }, {
            id: "ll-cart-icon-bubble"
        }]
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML
    }
    handleBodyClick(e) {
        const t = e.target;
        if (t !== this.notification && !t.closest("cart-notification")) {
            const i = t.closest("details-disclosure, header-menu");
            this.activeElement = i ? i.querySelector("summary") : null, this.close()
        }
    }
    setActiveElement(e) {
        this.activeElement = e
    }
}
customElements.define("ll-cart-notification", z);
var y, b;
class R extends HTMLElement {
    constructor() {
        super();
        a(this, y);
        a(this, b);
        this.button = this.querySelector(".site-selector__button"), this.listPopup = this.querySelector(".site-selector__list"), this.icon = this.querySelector(".site-selector__collapse-icon")
    }
    connectedCallback() {
        c(this, y, this.onSiteSelectorClicked.bind(this)), this.button.addEventListener("click", r(this, y)), c(this, b, this.onClickedOutside.bind(this)), document.addEventListener("click", r(this, b))
    }
    disconnectedCallback() {
        this.button.removeEventListener("click", r(this, y)), document.removeEventListener("click", r(this, b))
    }
    onSiteSelectorClicked() {
        const t = this.button.getAttribute("aria-expanded") === "true" || !1;
        this.button.setAttribute("aria-expanded", !t), this.icon.setAttribute("aria-expanded", !t), this.listPopup.style.display = t ? "none" : "block"
    }
    onClickedOutside(t) {
        this.contains(t.target) || (this.button.setAttribute("aria-expanded", "false"), this.icon.setAttribute("aria-expanded", "false"), this.listPopup.style.display = "none")
    }
}
y = new WeakMap, b = new WeakMap;
customElements.define("site-selector", R);
var m, v, x;
customElements.get("ll-announcement-bar") || customElements.define("ll-announcement-bar", (x = class extends HTMLElement {
    constructor() {
        super();
        a(this, m);
        a(this, v);
        c(this, m, "ll-announcement-bar-reappear-time"), this.closeButton = this.querySelector('[data-action="close"]')
    }
    connectedCallback() {
        c(this, v, this.onCloseButtonClicked.bind(this)), this.closeButton.addEventListener("click", r(this, v));
        const t = localStorage.getItem(r(this, m));
        t ? Date.now() < t ? this.classList.add("hidden") : (localStorage.removeItem(r(this, m)), this.classList.remove("hidden")) : this.classList.remove("hidden")
    }
    disconnectedCallback() {
        this.closeButton.removeEventListener("click", r(this, v))
    }
    onCloseButtonClicked(t) {
        t.preventDefault(), t.stopPropagation();
        const i = this.dataset.daysTilReappear,
            o = Date.now() + i * 24 * 60 * 60 * 1e3;
        localStorage.setItem(r(this, m), o), this.classList.add("hidden")
    }
}, m = new WeakMap, v = new WeakMap, x));
var u, I;
customElements.get("ll-mobile-modal") || customElements.define("ll-mobile-modal", (I = class extends HTMLElement {
    constructor() {
        super();
        a(this, u);
        this.toggleButton = this.querySelector("[data-toggle]"), this.overlay = this.querySelector("[data-overlay]"), this.content = this.querySelector("[data-content]")
    }
    connectedCallback() {
        c(this, u, this.onClickToggler.bind(this)), this.toggleButton.addEventListener("click", r(this, u)), this.overlay.addEventListener("click", r(this, u))
    }
    disconnectedCallback() {
        this.toggleButton.removeEventListener("click", r(this, u)), this.overlay.removeEventListener("click", r(this, u))
    }
    onClickToggler() {
        this.content.toggleAttribute("displaying"), this.content.hasAttribute("displaying") && this.displayedCallback()
    }
    display() {
        this.content.setAttribute("displaying", ""), this.displayedCallback()
    }
    displayedCallback() {}
    hide() {
        this.content.removeAttribute("displaying"), document.body.dispatchEvent(new CustomEvent("modalClosed"))
    }
}, u = new WeakMap, I));
!customElements.get("ll-mobile-variant-selector") && customElements.get("ll-mobile-modal") && customElements.define("ll-mobile-variant-selector", class extends customElements.get("ll-mobile-modal") {
    constructor() {
        super();
        C(this, "productUrl");
        this.dynamicContent = this.querySelector("[data-dynamic-content]"), this.loadingIndicatorScript = this.querySelector("script[data-loading-indicator]"), this.loadingIndicator = this.loadingIndicatorScript ? this.loadingIndicatorScript.innerHTML : "Loading..."
    }
    displayProduct(t) {
        this.productUrl = t, this.displayLoading(), this.display()
    }
    displayLoading() {
        this.dynamicContent.innerHTML = this.loadingIndicator
    }
    displayedCallback() {
        fetch(this.productUrl).then(t => t.text()).then(t => {
            const o = new DOMParser().parseFromString(t, "text/html").querySelector(".ll-quick-add-product");
            this.dynamicContent.innerHTML = o.outerHTML
        })
    }
});
var L, D;
customElements.get("ll-card-product") || customElements.define("ll-card-product", (D = class extends HTMLElement {
    constructor() {
        super();
        a(this, L)
    }
    connectedCallback() {
        c(this, L, this.onClick.bind(this)), this.addEventListener("click", r(this, L))
    }
    disconnectedCallback() {
        this.removeEventListener("click", r(this, L))
    }
    onClick(t) {
        if (window.innerWidth <= 990 && this.dataset.shouldShowQuickAddModal == "true") {
            t.preventDefault();
            const o = document.querySelector("ll-mobile-variant-selector");
            o ? o.displayProduct(this.dataset.productUrl) : window.location.href = this.dataset.productBaseUrl
        }
    }
}, L = new WeakMap, D));
customElements.get("ll-quick-add-modal") || customElements.define("ll-quick-add-modal", class extends ModalDialog {
    constructor() {
        super(), this.modalContent = this.querySelector('[id^="QuickAddInfo-"]'), this.addEventListener("product-info:loaded", ({
            target: e
        }) => {
            e.addPreProcessCallback(this.preprocessHTML.bind(this))
        })
    }
    hide(e = !1) {
        const t = document.querySelector("ll-cart-notification") || document.querySelector("ll-cart-drawer");
        t && t.setActiveElement(this.openedBy), this.modalContent.innerHTML = "", e && (this.openedBy = null), super.hide()
    }
    show(e) {
        e.setAttribute("aria-disabled", !0), e.setAttribute("aria-loading", !0), e.classList.add("loading"), fetch(e.getAttribute("data-product-url")).then(t => t.text()).then(t => {
            const o = new DOMParser().parseFromString(t, "text/html").querySelector(".ll-quick-add-product");
            this.preprocessHTML(o), HTMLUpdateUtility.setInnerHTML(this.modalContent, o.outerHTML), window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), window.ProductModel && window.ProductModel.loadShopifyXR(), super.show(e)
        }).finally(() => {
            e.removeAttribute("aria-disabled"), e.removeAttribute("aria-loading"), e.classList.remove("loading")
        })
    }
    preprocessHTML(e) {
        e.classList.forEach(t => {
            (t.startsWith("color-") || t === "gradient") && this.modalContent.classList.add(t)
        }), this.preventDuplicatedIDs(e), this.removeDOMElements(e), this.removeGalleryListSemantic(e), this.updateImageSizes(e), this.preventVariantURLSwitching(e)
    }
    preventVariantURLSwitching(e) {
        e.setAttribute("data-update-url", "false")
    }
    removeDOMElements(e) {
        const t = e.querySelector("pickup-availability");
        t && t.remove();
        const i = e.querySelector("product-modal");
        i && i.remove();
        const o = e.querySelectorAll("modal-dialog");
        o && o.forEach(n => n.remove())
    }
    preventDuplicatedIDs(e) {
        const t = e.dataset.section,
            i = t,
            o = `quickadd-${t}`;
        e.innerHTML = e.innerHTML.replaceAll(i, o), Array.from(e.attributes).forEach(n => {
            n.value.includes(i) && e.setAttribute(n.name, n.value.replace(i, o))
        }), e.dataset.originalSection = t
    }
    removeGalleryListSemantic(e) {
        const t = e.querySelector('[id^="Slider-Gallery"]');
        t && (t.setAttribute("role", "presentation"), t.querySelectorAll('[id^="Slide-"]').forEach(i => i.setAttribute("role", "presentation")))
    }
    updateImageSizes(e) {
        const t = e.querySelector(".product");
        if (!(t == null ? void 0 : t.classList.contains("product--columns"))) return;
        const o = t.querySelectorAll(".product__media img");
        if (!o.length) return;
        let n = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        t.classList.contains("product--medium") ? n = n.replace("715px", "605px") : t.classList.contains("product--small") && (n = n.replace("715px", "495px")), o.forEach(l => l.setAttribute("sizes", n))
    }
});
var S, k, P;
if (!customElements.get("ll-slider-dots")) {
    class s extends HTMLElement {
        constructor() {
            super();
            a(this, k);
            a(this, S);
            this.activeSlideIndex = 0, this.getAttribute("data-slide-count") ? this.slideCount = document.querySelectorAll('.hero-slider > [id^="Slide-"]').length || this.getAttribute("data-slide-count") || 0 : window.matchMedia("(min-width: 1024px)").matches ? this.slideCount = this.getAttribute("data-slide-count-desktop") || 0 : this.slideCount = this.getAttribute("data-slide-count-mobile") || 0
        }
        connectedCallback() {
            this.render(), c(this, S, T(this, k, P).bind(this)), this.addEventListener("click", r(this, S))
        }
        disconnectedCallback() {
            this.removeEventListener("click", r(this, S))
        }
        attributeChangedCallback(i, o, n) {
            if (i === "data-active-slide-index") {
                const l = parseInt(n);
                this.activeSlideIndex != l && (this.activeSlideIndex = l, this.renderActiveDot())
            }
        }
        static get observedAttributes() {
            return ["data-active-slide-index"]
        }
        render() {
            const i = Array.from({
                length: this.slideCount
            }, (o, n) => `<span class="${n===this.activeSlideIndex?"dot active":"dot"}" data-slide-index="${n}"></span>`).join("");
            this.innerHTML = `
        <div class="dots color-scheme-1">
          ${i}
        </div>
      `.trim()
        }
        renderActiveDot(i = null) {
            this.querySelectorAll(".dot").forEach(o => o.classList.remove("active")), i || (i = this.querySelector(`.dot[data-slide-index="${this.activeSlideIndex}"]`)), i && i.classList.add("active")
        }
    }
    S = new WeakMap, k = new WeakSet, P = function(i) {
        i.preventDefault();
        const o = i.target;
        o.classList.contains("dot") && (this.activeSlideIndex = parseInt(o.getAttribute("data-slide-index")), this.renderActiveDot(o), this.dispatchEvent(new CustomEvent("slideChanged", {
            detail: this.activeSlideIndex
        })))
    }, customElements.define("ll-slider-dots", s)
}
var E;
class U extends HTMLElement {
    constructor() {
        super();
        a(this, E, !1);
        if (this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.sliderDots = this.querySelector("ll-slider-dots"), this.stopsAutoplayOnFocus = this.getAttribute("stops-autoplay-on-focus") !== "false", !this.canSlide()) return;
        this.initPages(), new ResizeObserver(i => this.initPages()).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton && this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton && this.nextButton.addEventListener("click", this.onButtonClick.bind(this)), this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)"), this.reducedMotion.addEventListener("change", () => {
            this.slider.getAttribute("data-autoplay") === "true" && this.setAutoPlay()
        }), this.slider.getAttribute("data-autoplay") === "true" && this.setAutoPlay()
    }
    setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1e3, this.stopsAutoplayOnFocus && (this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this))), this.querySelector(".slideshow__autoplay") ? (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.autoplayButtonIsSetToPlay = !0, this.play()) : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play()
    }
    canSlide() {
        return this.slider && (this.nextButton || this.sliderDots)
    }
    connectedCallback() {
        this.sliderDots && this.sliderDots.addEventListener("slideChanged", t => {
            c(this, E, !0), this.setSlidePosition(t.detail * this.sliderItemOffset), setTimeout(() => {
                c(this, E, !1)
            }, 1e3)
        })
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(t => t.clientWidth > 0), !(this.sliderItemsToShow.length < 2) && (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
    }
    update() {
        if (!this.canSlide()) return;
        this.slider.getAttribute("data-autoplay") === "true" && this.resetTimer();
        const t = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != t && (this.dispatchEvent(new CustomEvent("slideChanged", {
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        })), this.sliderDots && !r(this, E) && this.sliderDots.setAttribute("data-active-slide-index", this.currentPage - 1)), !this.enableSliderLooping && this.nextButton && (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0 ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }
    focusOutHandling(t) {
        if (this.sliderAutoplayButton) {
            const i = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
            if (!this.autoplayButtonIsSetToPlay || i) return;
            this.play()
        } else !this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.play()
    }
    focusInHandling(t) {
        this.sliderAutoplayButton ? (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause() : this.slider.contains(t.target) && this.pause()
    }
    autoRotateSlides() {
        const t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
        this.setSlidePosition(t)
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), this.resetTimer()
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
    }
    resetTimer() {
        clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }
    isSlideVisible(t, i = 0) {
        const o = this.slider.clientWidth + this.slider.scrollLeft - i;
        return t.offsetLeft + t.clientWidth <= o && t.offsetLeft >= this.slider.scrollLeft
    }
    onButtonClick(t) {
        t.preventDefault();
        const i = t.currentTarget.dataset.step || 1;
        this.slideScrollPosition = t.currentTarget.name === "next" ? this.slider.scrollLeft + i * this.sliderItemOffset : this.slider.scrollLeft - i * this.sliderItemOffset, this.setSlidePosition(this.slideScrollPosition)
    }
    setSlidePosition(t) {
        this.slider.scrollTo({
            left: t
        })
    }
}
E = new WeakMap;
customElements.define("ll-slider-component", U);
if (!window.HorizontalScrollBaseDefined) {
    class s extends HTMLElement {
        constructor() {
            super(), this._content = this.querySelector(".horizontal-scroll__content"), this._isDragging = !1, this._dragStartX = 0, this._dragStartScrollLeft = 0
        }
        connectedCallback() {
            this._mouseDownListener = this._onMouseDown.bind(this), this._mouseMoveListener = this._onMouseMove.bind(this), this._mouseUpListener = this._onMouseUp.bind(this), this._mouseLeaveListener = this._onMouseUp.bind(this), "ontouchstart" in window || (this._content.addEventListener("mousedown", this._mouseDownListener), document.addEventListener("mousemove", this._mouseMoveListener), document.addEventListener("mouseup", this._mouseUpListener), this._content.addEventListener("mouseleave", this._mouseLeaveListener))
        }
        disconnectedCallback() {
            "ontouchstart" in window || (this._content.removeEventListener("mousedown", this._mouseDownListener), document.removeEventListener("mousemove", this._mouseMoveListener), document.removeEventListener("mouseup", this._mouseUpListener), this._content.removeEventListener("mouseleave", this._mouseLeaveListener))
        }
        _onMouseDown(t) {
            t.button === 0 && (this._isDragging = !0, this._content.classList.add("dragging"), this._dragStartX = t.pageX, this._dragStartScrollLeft = this._content.scrollLeft, this._content.style.scrollBehavior = "auto", t.preventDefault())
        }
        _onMouseMove(t) {
            if (!this._isDragging) return;
            const i = t.pageX - this._dragStartX;
            this._content.scrollLeft = this._dragStartScrollLeft - i, t.preventDefault()
        }
        _onMouseUp(t) {
            this._isDragging && (this._isDragging = !1, this._content.classList.remove("dragging"), this._content.style.scrollBehavior = "")
        }
    }
    window.HorizontalScrollBaseDefined = !0, window.HorizontalScroll = s
}
if (!customElements.get("fading-horizontal-scroll")) {
    class s extends window.HorizontalScroll {
        constructor() {
            super(), this._scrollEndsOverlayLeft = this.querySelector(".fading-horizontal-scroll__overlay--left"), this._scrollEndsOverlayRight = this.querySelector(".fading-horizontal-scroll__overlay--right")
        }
        connectedCallback() {
            super.connectedCallback(), this._scrollWrapperScrollListener = this.handleScrollFadeEndsOpacity.bind(this), this._content.addEventListener("scroll", this._scrollWrapperScrollListener), window.addEventListener("resize", this._scrollWrapperScrollListener), this.handleScrollFadeEndsOpacity()
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this._content.removeEventListener("scroll", this._scrollWrapperScrollListener), window.removeEventListener("resize", this._scrollWrapperScrollListener)
        }
        handleScrollFadeEndsOpacity() {
            const t = this._content.scrollLeft,
                i = this._content.scrollWidth - this._content.clientWidth;
            this._scrollEndsOverlayLeft && (this._scrollEndsOverlayLeft.style.opacity = t > 0 ? 1 : 0), this._scrollEndsOverlayRight && (this._scrollEndsOverlayRight.style.opacity = t < i ? 1 : 0)
        }
    }
    customElements.define("fading-horizontal-scroll", s)
}
if (!customElements.get("infinite-horizontal-scroll")) {
    class s extends window.HorizontalScroll {
        constructor() {
            super();
            C(this, "_onScroll", () => {
                if (!this._content || !this._originalChildren) return;
                const i = this._content.scrollLeft;
                this._content.scrollWidth - this._content.clientWidth - i < this._cloneThreshold && this._originalChildren.forEach(n => {
                    this._content.appendChild(n.cloneNode(!0))
                })
            });
            this._cloneThreshold = 200, this._originalChildren = null, this._initialized = !1
        }
        _startAutoScroll() {
            const i = parseInt(this.getAttribute("data-auto-scroll-interval"), 10);
            !i || i <= 0 || (this._autoScrollTimer && clearInterval(this._autoScrollTimer), this._autoScrollTimer = setInterval(() => {
                if (!this._content) return;
                const o = this._content.scrollLeft,
                    n = o + this._content.clientWidth,
                    l = Array.from(this._content.querySelectorAll("img"));
                let h = !1;
                for (let p of l) {
                    const w = p.offsetLeft,
                        d = w + p.offsetWidth;
                    if (w >= o && d <= n) {
                        this._content.scrollTo({
                            left: d,
                            behavior: "smooth"
                        }), h = !0;
                        break
                    }
                }
                h || this._content.scrollBy({
                    left: 100,
                    behavior: "smooth"
                })
            }, i * 1e3))
        }
        connectedCallback() {
            super.connectedCallback(), this._content && (this._originalChildren || (this._originalChildren = Array.from(this._content.children).map(i => i.cloneNode(!0))), requestAnimationFrame(() => {
                this._content.scrollLeft = this._content.scrollWidth / 2, this._content.addEventListener("scroll", this._onScroll.bind(this)), setTimeout(() => {
                    this._initialized = !0, this._startAutoScroll()
                }, 1e3)
            }))
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this._content && this._content.removeEventListener("scroll", this._onScroll.bind(this)), this._autoScrollTimer && (clearInterval(this._autoScrollTimer), this._autoScrollTimer = null)
        }
    }
    customElements.define("infinite-horizontal-scroll", s)
}
customElements.get("ll-media-grid") || customElements.define("ll-media-grid", class extends HTMLElement {
    constructor() {
        super(), this.currentlyDisplayedMediaCount = 0, this.displayManagedByPage = this.dataset.displayManagedByPage == "true", this.preferredMediaCount = this.dataset.preferredMediaCount || 2, this.productTags = this.dataset.productTags ? this.dataset.productTags.split(",") : [], this.blocks = this.querySelectorAll('[data-tag="media-grid-item"]')
    }
    connectedCallback() {
        super.connectedCallback && super.connectedCallback(), this.displayManagedByPage && (this.renderBlocksConditionally(this.productTags), this.renderBlocksConditionally(["*", "placeholder"]), this.classList.remove("hidden"))
    }
    renderBlocksConditionally(e) {
        this.blocks.forEach(t => {
            const i = t.dataset.applicableTags ? t.dataset.applicableTags.split(",") : [],
                o = e.some(l => i.includes(l)),
                n = this.currentlyDisplayedMediaCount < this.preferredMediaCount;
            o && n && (t.classList.remove("hidden"), this.currentlyDisplayedMediaCount++)
        })
    }
});
class W extends HTMLElement {
    constructor() {
        super(), this.attachShadow({
            mode: "open"
        }), this.shadowRoot.innerHTML = `
      <style>
      #load-more {
        flex: 1;
        border-radius: 999px;
        border: none;
        cursor: pointer;
        text-transform: uppercase;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font: inherit;
        font-weight: 600;
        font-size: 1.5rem;
        letter-spacing: 0.1rem;
        border: 1px solid #6800CC;
        background: #6800CC;
        transition: all ease-in-out 0.5s;
        color: #fff;
        min-height: 56px;
        min-width: 175px;
        line-height: 18px;
        width: fit-content;
      }
      #load-more:hover {
        background: #fff;
        color: #6800CC;
      }
      </style>
      <button id="load-more" class="ll-button ll-button--primary">Load More</button>
    `
    }
    connectedCallback() {
        this.shadowRoot.querySelector("#load-more").addEventListener("click", this.loadMore.bind(this))
    }
    disconnectedCallback() {
        this.shadowRoot.querySelector("#load-more").removeEventListener("click", this.loadMore.bind(this))
    }
    loadMore() {
        let e = this.getAttribute("data-url"),
            t = this.getAttribute("data-section-id");
        e && fetch(e).then(i => i.text()).then(i => {
            let n = new DOMParser().parseFromString(i, "text/html"),
                l = n.querySelectorAll(`${t} .ll-collection-list__item`);
            n.getElementById("load-more"), l.forEach(d => document.querySelector(`${t}`).appendChild(d));
            let h = this.getAttribute("data-pagination"),
                p = this.getAttribute("data-url"),
                w = p.charAt(p.length - 1);
            if (w < h) {
                let d = p.slice(0, -1) + (parseInt(w) + 1);
                this.setAttribute("data-url", d)
            } else {
                let d = document.createElement("slot");
                d.setAttribute("name", "copy-at-end"), this.shadowRoot.querySelector("#load-more").remove(), this.shadowRoot.appendChild(d)
            }
        }).catch(i => {})
    }
}
customElements.define("load-more-button", W);
if (!customElements.get("ll-divider")) {
    class s extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.scrollSlightly()
        }
        scrollSlightly() {
            this.scrollTo(150, 0)
        }
    }
    customElements.define("ll-divider", s)
}